import React from 'react';
import { Inbox } from 'lucide-react';

const EmptyState = ({ title = 'No data found', message = 'There are no items to display.', icon: Icon = Inbox }) => {
  return (
    <div className="text-center py-12">
      <Icon className="mx-auto text-gray-300" size={48} />
      <h3 className="mt-4 text-lg font-medium text-gray-900">{title}</h3>
      <p className="mt-2 text-gray-500">{message}</p>
    </div>
  );
};

export default EmptyState;
